// @ts-ignore
import * as React from "react";
import type { PopupPositionsType } from "@skbkontur/react-ui";

export const feedbackButtonTourStep = {
    id: "candyform_feedbackbutton",
    header: "Напишите отзыв",
    onBefore: "showPanel",
    onAfter: "hidePanel",
    content: <div>{"Пишите замечания и пожелания — это поможет нам делать формы еще лучше. Легкой отчетности!"}</div>,
    group: ["panel", "menu"],
    positions: ["right middle", "right bottom"] satisfies PopupPositionsType[],
    offset: -20,
    order: 55,
};
